import { log } from "../utils/log_utils";
import apiClient from "../utils/api_client";


async function getUserBragsheet() {
    try {
      return await apiClient( '/user/bragsheet',{
        method: 'GET',
        credentials: "include"
      })
    } catch (error) {
      log("error getting user bragsheet",error,'getUserBragsheet');
      return { success: false, resp: error?.message || error }
    }

}


async function updateBragsheet(bragsheet) {
  try {
    return await apiClient('/user/update-bragsheet',{
      method: 'POST',
      credentials: "include",
      body: JSON.stringify({ bragsheet })
    })
  } catch (error) {
    log("error getting user bragsheet",error,'getUserBragsheet');
    return { success: false, resp: error?.message || error }
  }
}
export { getUserBragsheet, updateBragsheet }